export const values = { 
  idProduto: parseInt(process.env.REACT_APP_ID_PRODUTO || "0"),
  idVendedor: parseInt(process.env.REACT_APP_ID_VENDEDOR || "0"),
  urlVideoConferencia: process.env.REACT_APP_URL_VIDEO_CONFERENCIA || '',
  urlLocaisAtendimento: process.env.REACT_APP_URL_LOCAIS_ATENDIMENTO || ''
}
 